var cov_2bif2pk2pk = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/Prev.tsx",
      hash = "1b3965c22a437703df7a14198fa97e47f7d63da0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/Prev.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 31
        }
      },
      "1": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 12,
          column: 23
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 5
        }
      },
      "3": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 43
        }
      },
      "4": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 40
        }
      },
      "5": {
        start: {
          line: 20,
          column: 60
        },
        end: {
          line: 20,
          column: 70
        }
      },
      "6": {
        start: {
          line: 21,
          column: 17
        },
        end: {
          line: 21,
          column: 28
        }
      },
      "7": {
        start: {
          line: 22,
          column: 22
        },
        end: {
          line: 22,
          column: 74
        }
      },
      "8": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "9": {
        start: {
          line: 31,
          column: 0
        },
        end: {
          line: 31,
          column: 43
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 15
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 11
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 23
          }
        }, {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 14,
            column: 43
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 21
          }
        }, {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 40
          }
        }],
        line: 16
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 22,
            column: 47
          },
          end: {
            line: 22,
            column: 64
          }
        }, {
          start: {
            line: 22,
            column: 67
          },
          end: {
            line: 22,
            column: 74
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 32
          }
        }, {
          start: {
            line: 22,
            column: 36
          },
          end: {
            line: 22,
            column: 44
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 24,
            column: 56
          },
          end: {
            line: 24,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 56
          },
          end: {
            line: 24,
            column: 64
          }
        }, {
          start: {
            line: 24,
            column: 68
          },
          end: {
            line: 24,
            column: 76
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Pagination/Prev.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import icons from '../icons';
import Item from './Item';
import { isRTL } from '../config';

var Prev =
/*#__PURE__*/
function (_ref) {
  _inherits(Prev, _ref);

  var _super = _createSuper2(Prev);

  function Prev() {
    _classCallCheck(this, Prev);

    return _super.apply(this, arguments);
  }

  _createClass(Prev, [{
    key: "renderPrev",
    value: function renderPrev() {
      cov_2bif2pk2pk.f[0]++;

      var _ref2 = (cov_2bif2pk2pk.s[0]++, this.props),
          text = _ref2.text;

      var rtl = (cov_2bif2pk2pk.s[1]++, isRTL());
      cov_2bif2pk2pk.s[2]++;

      if (rtl) {
        cov_2bif2pk2pk.b[0][0]++;
        cov_2bif2pk2pk.s[3]++;
        return (cov_2bif2pk2pk.b[1][0]++, text.next) || (cov_2bif2pk2pk.b[1][1]++, icons.AngleRight);
      } else {
        cov_2bif2pk2pk.b[0][1]++;
      }

      cov_2bif2pk2pk.s[4]++;
      return (cov_2bif2pk2pk.b[2][0]++, text.prev) || (cov_2bif2pk2pk.b[2][1]++, icons.AngleLeft);
    }
  }, {
    key: "render",
    value: function render() {
      cov_2bif2pk2pk.f[1]++;

      var _ref3 = (cov_2bif2pk2pk.s[5]++, this.props),
          onChange = _ref3.onChange,
          current = _ref3.current,
          text = _ref3.text,
          disabled = _ref3.disabled,
          isSimple = _ref3.isSimple;

      var prev = (cov_2bif2pk2pk.s[6]++, current - 1);
      var className = (cov_2bif2pk2pk.s[7]++, (cov_2bif2pk2pk.b[4][0]++, text.prev) || (cov_2bif2pk2pk.b[4][1]++, isSimple) ? (cov_2bif2pk2pk.b[3][0]++, "no-border arrow") : (cov_2bif2pk2pk.b[3][1]++, 'arrow'));
      cov_2bif2pk2pk.s[8]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          className: className,
          page: prev,
          disabled: (cov_2bif2pk2pk.b[5][0]++, disabled) || (cov_2bif2pk2pk.b[5][1]++, prev < 1),
          onClick: onChange,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 7
          }
        }, this.renderPrev())
      );
    }
  }]);

  return Prev;
}((React.PureComponent));

Prev.displayName = void 0;
cov_2bif2pk2pk.s[9]++;
Prev.displayName = 'ShineoutPaginationPrev';
export default Prev;